export class AppSettingsBinder {
  async appSettingsBinder() {
    try {
      const response = await fetch("/globalSettings/launchsettings.json?v=" + Date.now());
      const data = await response.json();

      // eslint-disable-next-line no-undef
      await this.#appSettingBind(data);
    } catch (error) {
      console.error("Bir hata oluştu:", error);
    }
  }

  async #appSettingBind(launchsettings) {
    const env = launchsettings.launch.environment;
    const configMap = {
      "Local": "/globalSettings/appsettingsDevelopment.json",
      "Test": "/globalSettings/appsettingsTest.json",
      "Server": "/globalSettings/appsettings.json"
    };
    const configPath = configMap[env] || configMap["Server"];

    try {
      const response = await fetch(configPath + "?v=" + Date.now());
      const data = await response.json();
      window.appsettings = data;
    } catch (error) {
      console.error("Config yüklenirken hata oluştu:", error);
    }
  }
}
